<template>
  <div class="backgroud-white cs-appointment-info" v-loading="isLoading">
    <div :class="{ 'backgroud-gray-popup': !isView, 'popup-content-area cs-courseSchedule-content': true }">
      <el-row class="cs-appointment-header-title" v-if="!isView">
        <el-col>
          <span class="el-dialog__title">{{ title }}</span>
        </el-col>
      </el-row>
      <div class="panel-title" v-if="isView">
        <el-button type="text" icon="el-icon-arrow-left" @click="onBack">返回</el-button>
      </div>

      <div v-if="!isDoingCancel">
        <el-row>
          <el-col :span="12">
            <el-form label-width="100px">
              <el-form-item label="日期:">
                <span>{{ date }}</span>
              </el-form-item>
              <el-form-item label="校区:">
                <span>{{ campusName }}</span>
              </el-form-item>
              <el-form-item label="预约课程:">
                <span>{{ courseName }}</span>
              </el-form-item>
              <el-form-item label="签到:">
                <span>{{ signInText }}</span>
                <span v-if="index > 0" class="cs-appointment-info-index">第{{ index }}次预约</span>
              </el-form-item>
              <el-form-item label="付款:" v-if="balanceCost > 0 || bonusPointCost > 0">
                <span v-if="balanceCost > 0">余额 ${{ balanceCost }}</span>
                <span v-if="bonusPointCost > 0">积分 {{ bonusPointCost }}(${{ bonusPointPrice }})</span>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form label-width="100px">
              <el-form-item label="预约时间:">
                <span>{{ startTime }} - {{ endTime }}</span>
              </el-form-item>
              <el-form-item label="电脑:">
                <span>{{ computerName }}</span>
              </el-form-item>
              <el-form-item label="课程周:">
                <span>{{ weekText }}</span>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-if="!isStudent">
          <el-col>
            <el-form label-width="100px">
              <el-form-item label="验证码:">
                <span v-if="token">
                  {{ token }}
                  <span v-if="isTokenConfirmed" class="cs-redLabel">(已验证)</span>
                </span>
                <span v-else class="cs-redLabel">未生成(学生点击观看时生成)</span>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-if="status === 6">
          <el-col :span="24">
            <el-form label-width="100px">
              <el-form-item label="已取消:">
                <span>{{ cancelReason }}</span>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row v-if="isWorkflowRefund">
          <el-col :span="24">
            <el-form label-width="100px">
              <el-form-item label="已退款:">
                <span v-if="refundBalanceCost > 0">退余额{{ refundBalanceCost }}</span>
                <span v-if="refundBonusPointCost > 0">退积分{{ refundBonusPointCost }}(${{ refundBonusPointPrice }})</span>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div v-if="status === 5 || !!applicationDescription || fileList.length > 0" class="cs-appointment-info-application">
          <el-row>
            <el-col :span="4">
              <span>特殊申请：</span>
            </el-col>
            <el-col :span="20">
              <div>
                <span>{{ applicationDescription }}</span>
              </div>
              <div class="cs-appointment-info-file" v-for="(file, index) in fileList" :key="index">
                <a class="cs-appointment-info-fileName" :href="file.FilePath + sasKey" type="text"
                  target="_blank">{{ file.FileName }}</a>
                上传于
                <span>{{ file.DateText }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row v-if="status === 5">
            <el-col :span="4">
              <span class="cs-redLabel">未通过审核：</span>
            </el-col>
            <el-col :span="20">
              <span>{{ cancelReason }}</span>
            </el-col>
          </el-row>
        </div>

        <div v-if="isApprove && !isView && !isStudent" class="cs-appointment-info-reasonContainer">
          <el-input class="cs-appointment-info-reason" type="textarea" :rows="5" placeholder="若不通过，请管理员说明原因"
            v-model="reason" />
        </div>
      </div>

      <div v-if="isDoingCancel && !isView" class="cs-appointment-info-cancelContainer">
        <el-row>
          <el-col>
            <span>确定要取消该预约吗？</span>
          </el-col>
        </el-row>
        <el-row v-show="false">
          <el-col>
            <span>是否退款:</span>
            <el-radio-group v-model="isRefund" size="mini">
              <el-radio-button label="是"></el-radio-button>
              <el-radio-button label="否"></el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row v-if="balanceCost > 0 && isRefund == '是'">
          <el-col>
            <span>退款至账户余额： ${{ balanceCost }}</span>
          </el-col>
        </el-row>
        <el-row v-if="bonusPointCost > 0 && isRefund == '是'">
          <el-col>
            <span>退款至账户积分： {{ bonusPointCost }}({{ bonusPointPrice }})</span>
          </el-col>
        </el-row>
        <div class="cs-appointment-info-reasonContainer">
          <el-input class="cs-appointment-info-reason" type="textarea" :rows="5" placeholder="若取消，请管理员说明原因"
            v-model="reason"></el-input>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer popup-footer" v-if="!isView && !isStudent">
      <el-row v-if="status === 3 && isClosed">
        <el-col>
          <el-alert :closable="false" title="预约已超时，不能审核" type="error" show-icon />
          <br />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" v-if="!isDoingCancel">
          <el-button v-if="isCancel" type="danger" @click="onCancel()">取消预约</el-button>

          <el-button v-if="!isApprove" type="primary" @click="onConfirm">确认</el-button>

          <el-button v-if="isApprove" type="danger" @click="onReject()">不通过</el-button>

          <el-button v-if="isApprove" type="primary" :disabled="isClosed" @click="onApprove">通过审核</el-button>
        </el-col>
        <el-col :span="24" v-if="isDoingCancel">
          <el-button v-if="!isApprove" type="primary" @click="onConfirm">保留</el-button>

          <el-button v-if="isCancel" type="danger" @click="onConfirmCancel()">取消预约</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss">
.cs-appointment-info {

  .el-form-item__label,
  .el-form-item__content {
    line-height: 30px;
  }

  .cs-appointment-info-index{
    display: block;
  }
}
</style>

<style lang="scss" scoped>
.cs-appointment-info {
  .cs-appointment-header-title {
    text-align: center;
    margin: 1rem 0;
  }

  .cs-appointment-info-info {
    text-align: center;
    color: #568199;
    background-color: #f9fbfd;
    margin-bottom: 1rem;

    span {
      display: block;
      padding: 1rem 0;
    }
  }

  .cs-appointment-info-content {
    padding: 1rem;
  }

  .cs-appointment-info-file {
    line-height: 30px;
  }

  .cs-appointment-info-fileName {
    color: #59c2e6;
  }

  .cs-appointment-info-application {
    margin-top: 1rem;
    padding-top: 1rem;
    padding-left: 1rem;
    border-top: 1px solid #dbdbdb;
  }

  .popup-footer {
    padding: 0 50px;
    margin-right: 0;
    text-align: center;
  }

  .cs-appointment-info-reasonContainer {
    padding: 1rem 2rem 0 2rem;

    .cs-appointment-info-reason {}
  }

  .cs-appointment-info-cancelContainer {
    .el-radio-group {
      margin-top: 5px;
    }
  }
}

.el-form-item {
  margin-bottom: 0px;
}
</style>

<script>
import { getSharedAccessSignature } from "../../service/blobStorage.service";
import { operateVideoAppointment, getVideoAppointment } from "../../service/videoAppointment.service";

export default {
  data() {
    return {
      isLoading: false,
      isView: false,
      sasKey: "",
      title: "",
      isRefund: "否",
      reason: "",
      date: "",
      startTime: "",
      endTime: "",
      campusName: "",
      computerName: "",
      courseName: "",
      weekText: "",
      signInText: "",
      index: 0,
      token: "",
      isTokenConfirmed: false,
      isApprove: false,
      isCancel: false,
      applicationDescription: "",
      fileList: [],

      isDoingCancel: false,
      balanceCost: 0,
      bonusPointCost: 0,
      bonusPointPrice: 0,

      status: 0,
      cancelReason: "",
      isStudent: false,
      isClosed: false,
      isWorkflowRefund: false,
      refundOldBalanceCost: 0,
      refundNewBalanceCost: 0,
      refundGiftBalanceCost: 0,
      refundBalanceCost: 0,
      refundBonusPointCost: 0,
      refundBonusPointPrice: 0
    };
  },
  components: {},
  created() {
    getSharedAccessSignature().then(result => {
      if (!!result && result.success) {
        this.sasKey = result.data;
      }
    });
    this.init();
  },
  props: {
    dataIn: {
      id: Number,
      isView: Boolean,
      isCancel: Boolean
    }
  },
  methods: {
    async init() {
      this.title = "预约详情";
      this.date = "";
      this.startTime = "";
      this.endTime = "";
      this.campusName = "";
      this.computerName = "";
      this.courseName = "";
      this.weekText = "";
      this.signInText = "";
      this.index = 0;
      this.isApprove = false;
      this.isCancel = false;
      this.applicationDescription = "";
      this.fileList = [];
      this.isDoingCancel = false;
      this.status = 0;
      this.token = "";
      this.isTokenConfirmed = false;
      this.isRefund = "否";
      this.status = 0;
      this.reason = "";
      this.cancelReason = "";
      this.isClosed = false;
      this.isWorkflowRefund = false;
      this.refundOldBalanceCost = 0;
      this.refundNewBalanceCost = 0;
      this.refundGiftBalanceCost = 0;
      this.refundBalanceCost = 0;
      this.refundBonusPointCost = 0;
      this.refundBonusPointPrice = 0;

      if (!this.dataIn || !this.dataIn.id) {
        return;
      }
      this.isStudent = this.USERMANAGER.isStudent;
      this.isView = !!this.dataIn.isView;
      //this.isCancel = this.dataIn.isCancel;
      this.isLoading = true;

      let result = await getVideoAppointment(this.dataIn.id);
      if (!!result && result.success) {
        let data = result.data;
        if (data.ScheduleList.length > 0) {
          let schedule = data.ScheduleList[0];

          this.date = schedule.DateText;
          this.startTime = schedule.StartTimeText;
          this.endTime = schedule.EndTimeText;
          this.campusName = schedule.CampusName;
          this.computerName = schedule.ComputerName;
        }

        this.courseName = data.CourseName;
        this.weekText = data.WeekText;
        this.signInText = data.SignInText;
        this.index = data.AppointmentIndex;
        this.isApprove = data.Status == 3;
        this.isCancel = data.Status != 6;
        this.applicationDescription = data.ApplicationDescription;
        this.fileList = data.FileList;
        this.balanceCost = data.BalanceCost;
        this.bonusPointCost = data.BonusPointCost;
        this.bonusPointPrice = data.BonusPointPrice;
        this.token = data.Token;
        this.isTokenConfirmed = data.IsTokenConfirmed;
        this.status = data.Status;
        this.cancelReason = data.Reason;
        this.isClosed = data.IsClosed;
        this.isWorkflowRefund = data.IsRefunded;
        this.refundOldBalanceCost = data.RefundOldBalanceCost;
        this.refundNewBalanceCost = data.RefundNewBalanceCost;
        this.refundGiftBalanceCost = data.RefundGiftBalanceCost;
        this.refundBalanceCost = data.RefundBalanceCost;
        this.refundBonusPointCost = data.RefundBonusPointCost;
        this.refundBonusPointPrice = data.RefundBonusPointPrice;
      }
      this.isLoading = false;
    },
    onConfirm() {
      this.$emit("close");
    },
    onConfirmCancel() {
      this.changeStatus(6);
    },
    onCancel() {
      this.title = "取消预约";
      this.isDoingCancel = true;
    },
    onReject() {
      this.changeStatus(5);
    },
    onApprove() {
      this.changeStatus(4);
    },
    changeStatus(status) {
      if (!this.reason && (status == 5 || status == 6)) {
        this.$message.warning("请输入原因");
        return;
      }

      operateVideoAppointment(this.dataIn.id, status, this.isRefund == "是", this.reason).then(result => {
        if (!!result && result.success) {
          this.$emit("reload");
        } else {
          let message = result.message;
          if (!message) {
            message = "保存失败";
          }
          this.$message.error(message);
        }
      });
    },
    async onBack() {
      this.$emit("close");
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappInfo.vue